import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UIProjectUsersRefreshService {
  readonly refresh$ = new BehaviorSubject<void>(undefined);
}
